var $ = require('jquery'),
	_ = require('underscore'),
	bus = $({});

module.exports = {
	publish: function (topic) {
		var args = _.toArray(arguments);
		args.shift();
		bus.trigger(topic, { args: args });
	},

	subscribe: function (topic, fn) {
		function trigger(event, data) {
			fn.apply(null, data.args);
		}

		bus.on(topic, trigger);

		return function unsubscribe() {
			bus.off(topic, trigger);
		};
	},

	subscribeOnce: function (topic, fn) {
		var trigger = function (event, data) {
			fn.apply(null, data.args);
		};

		bus.one(topic, trigger);

		return function unsubscribe() {
			bus.off(topic, trigger);
		};
	}
};
